export default __webpack_public_path__ + "_/images/hidden_temple_en-93811c972d84ed6f22f608734a336f7758be8c75ebd61b2631e5152af13fe5fd.jpg";